import { useContext } from 'react';
import MainCard from '../../../components/MainCard/Index';
import Exemptions from '../CandidateArea/ExemptionComponent/Index';
import { ContextAuth } from '../../../contexts/Authentication';
import ExemptionMobilePage from './mobile/list';

const ExemptionsPage: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);

  if (isMobile) return <ExemptionMobilePage />;

  return (
    <MainCard height="100%" title="ÁREA DO CANDIDATO - " subtitle="MINHAS ISENÇÕES">
      <Exemptions />
    </MainCard>
  );
};

export default ExemptionsPage;
